<div style="display: flex; justify-content: center">
  @if (!isMobileView) {
  <sco-dialog
    [icon]="'bi bi-arrow-left-right'"
    title="{{ 'COUNTRY_ROLE_DIALOG_HEADER_TITLE' | translate }}"
    [showFooter]="true"
    (scoDialogCloseClicked)="cancelDialog()">
    <p style="max-width: 516px">{{ 'COUNTRY_ROLE_INFO_TEXT' | translate }}</p>
    @if (landRole$ | async; as landRole) {
    <div style="display: flex; gap: 1rem; margin-top: 1rem">
      <div style="flex: 1">
        <sco-select
          label="{{ 'COUNTRY' | translate }}"
          [options]="transformToSelectItems(landRole.countries)"
          [(ngModel)]="selectedCountryId"
          [isSearchable]="true"
          [searchPlaceholder]="''"></sco-select>
      </div>
      <div style="flex: 1">
        <sco-select
          label="{{ 'ROLE' | translate }}"
          [options]="transformToSelectItems(landRole.roles)"
          [(ngModel)]="selectedRoleId"
          [isSearchable]="true"
          [searchPlaceholder]="''"></sco-select>
      </div>
    </div>
    }
    <ng-container footerRight>
      <button scoButton variant="link" (click)="cancelDialog()">{{ 'CANCEL' | translate }}</button>
      <button
        scoButton
        (click)="setView()"
        [disabled]="!selectedCountryId || !selectedRoleId || isSetViewActive"
        [isLoading]="isSetViewActive">
        {{ 'SET_VIEW' | translate }}
      </button>
    </ng-container>
  </sco-dialog>
  }

  <!-- MOBILE VIEW -->
  @if (isMobileView) {
  <div class="land-role-dialog-mobile-wrapper">
    <!-- Header -->
    <div class="mobile-header">
      <div class="mobile-header-title">
        <i class="bi bi-arrow-left-right"></i>
        <span class="title">{{ 'COUNTRY_ROLE_DIALOG_HEADER_TITLE' | translate }}</span>
      </div>
      <button scoButton variant="link" [onlyIcon]="true" (click)="cancelDialog()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>
    <!-- Content -->
    <div class="mobile-content">
      <p>{{ 'COUNTRY_ROLE_INFO_TEXT' | translate }}</p>
      @if (landRole$ | async; as landRole) {
      <div class="dropdowns-wrapper">
        <sco-select
          label="{{ 'COUNTRY' | translate }}"
          [options]="transformToSelectItems(landRole.countries)"
          [(ngModel)]="selectedCountryId"
          [isSearchable]="true"
          [searchPlaceholder]="''"></sco-select>
        <sco-select
          label="{{ 'ROLE' | translate }}"
          [options]="transformToSelectItems(landRole.roles)"
          [(ngModel)]="selectedRoleId"
          [isSearchable]="true"
          [searchPlaceholder]="''"></sco-select>
      </div>
      }
    </div>
    <!-- Footer -->
    <div class="mobile-footer">
      <button scoButton (click)="setView()" [disabled]="!selectedCountryId || !selectedRoleId" variant="primary">
        {{ 'SET_VIEW' | translate }}
      </button>
    </div>
  </div>
  }
</div>
